import React from 'react'
import theme from 'theme'

const Icons = {
  arrowLeft: ({ stroke = theme.gray, strokeWidth = 2, width = 11, height = 18, style }) => (
    <svg width={width} height={height} viewBox="0 0 11 18" fill="none" style={style}>
      <path d="M10 1L2 9L10 17" stroke={stroke} strokeWidth={strokeWidth} />
    </svg>
  ),
  arrowRight: ({ stroke = theme.gray, strokeWidth = 2, width = 11, height = 18, style }) => (
    <svg width={width} height={height} viewBox="0 0 11 18" fill="none" style={style}>
      <path d="M1 17L9 9L0.999999 1" stroke={stroke} strokeWidth={strokeWidth} />
    </svg>
  ),
  back: ({ fill = theme.black, width = 21, height = 14 }) => (
    <svg width={width} height={height} viewBox="0 0 21 14" fill={fill}>
      <path
        d="M18.7895 1.16667V5.83333H4.23316L8.19 1.645L6.63158 0L0 7L6.63158 14L8.19 12.355L4.23316 8.16667H21V1.16667H18.7895Z"
        fill={fill}
      />
    </svg>
  ),
  cross: ({ stroke = theme.white, strokeWidth = 2, width = 32, height = 32 }) => (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none">
      <path d="M23.0596 7.46063L7.46061 23.0596" stroke={stroke} strokeWidth={strokeWidth} />
      <path d="M23.7373 23.0594L8.13835 7.46043" stroke={stroke} strokeWidth={strokeWidth} />
    </svg>
  ),
  desktop: ({ fill = theme.white, width = 29, height = 24 }) => (
    <svg width={width} height={height} viewBox="0 0 29 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28.9376 22.6308L26.9726 15.8298V1.02128C26.9726 0.456383 26.5081 0 25.9332 0H3.06682C2.49191 0 2.02744 0.456383 2.02744 1.02128V15.8298L0.0623585 22.6308C-0.181246 23.2979 0.318955 24 1.04003 24H27.96C28.681 24 29.1812 23.2979 28.9376 22.6308ZM4.36604 2.29787H24.634V14.9043H4.36604V2.29787ZM11.7814 21.7021L12.0445 20.5213H16.9263L17.1894 21.7021H11.7814ZM19.057 21.7021L18.4366 18.9351C18.4107 18.817 18.3035 18.734 18.1833 18.734H10.7907C10.6673 18.734 10.5633 18.817 10.5374 18.9351L9.91698 21.7021H2.7615L4.13543 16.9468H24.8646L26.2385 21.7021H19.057Z"
        fill={fill}
      />
    </svg>
  ),
  fullscreen: ({ fill = theme.gray, width = 23, height = 22 }) => (
    <svg width={width} height={height} viewBox="0 0 23 22">
      <path
        d="M3.22 17.38L0 14.3V22H8.05L4.83 18.92L9.821 14.168L8.188 12.606L3.22 17.38ZM19.78 4.62L23 7.7V0H14.95L18.17 3.08L13.179 7.832L14.812 9.394L19.78 4.62ZM18.17 18.92L14.95 22H23V14.3L19.78 17.38L14.812 12.606L13.179 14.168L18.1585 18.931L18.17 18.92ZM4.83 3.08L8.05 0H0V7.7L3.22 4.62L8.188 9.394L9.821 7.832L4.83 3.08Z"
        fill={fill}
      />
    </svg>
  ),
  headphones: ({ fill, width = 36, height = 36 }) => (
    <svg width={width} height={height} viewBox="0 0 36 36">
      <path
        d="M17.7778 0C7.97508 0 0 8.70031 0 19.394V28.2828C0 28.7291 0.361818 29.0909 0.808107 29.0909H3.23235V32.3233C3.23235 34.1059 4.68197 35.5556 6.4647 35.5556H8.88895C9.33561 35.5556 9.69705 35.1942 9.69705 34.7475V20.2021C9.69705 19.7554 9.33561 19.394 8.88895 19.394H6.4647C4.68205 19.394 3.23235 20.8436 3.23235 22.6263V19.394C3.23235 10.4822 9.75774 3.23235 17.7778 3.23235C25.7979 3.23235 32.3233 10.4822 32.3233 19.394V22.6263C32.3233 20.8436 30.8736 19.394 29.0909 19.394H26.6667C26.22 19.394 25.8586 19.7554 25.8586 20.2021V34.7475C25.8586 35.1942 26.22 35.5556 26.6667 35.5556H29.0909C30.8736 35.5556 32.3233 34.106 32.3233 32.3233V29.0909H34.7475C35.1938 29.0909 35.5556 28.7291 35.5556 28.2828V19.394C35.5556 8.70031 27.5806 0 17.7778 0Z"
        fill={fill}
      />
    </svg>
  ),
  pause: ({ stroke = theme.black, width = 10, height = 12, strokeWidth = 3 }) => (
    <svg width={width} height={height} viewBox="0 0 10 12" fill="none">
      <path d="M2.29297 0V12" stroke={stroke} strokeWidth={strokeWidth} />
      <path d="M8.29297 0V12" stroke={stroke} strokeWidth={strokeWidth} />
    </svg>
  ),
  play: ({ fill = theme.black, width = 16, height = 12 }) => (
    <svg width={width} height={height} viewBox="0 0 24 26" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path d="M24 13L0.750001 25.9904L0.750002 0.00961774L24 13Z" fill={fill} />
    </svg>
  ),
  plus: ({ stroke = theme.black, strokeWidth = 2, width = 22, height = 22 }) => (
    <svg width={width} height={height} viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.5508 0L10.5508 22.0603" stroke={stroke} strokeWidth={strokeWidth} />
      <path d="M22.0605 10.5507L0.000285685 10.5507" stroke={stroke} strokeWidth={strokeWidth} />
    </svg>
  ),
  scroll: ({ stroke = theme.white, width = 18, height = 24, strokeWidth = 2 }) => (
    <svg width={width} height={height} viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1L9 9L17 1" stroke={stroke} strokeWidth={strokeWidth} />
      <path d="M17 23L9 15L1 23" stroke={stroke} strokeWidth={strokeWidth} />
    </svg>
  ),
}

export default Icons
